import React, { useState } from 'react';
import ResponseReviewerSelect from 'v2/common/ResponseReviewerSelect/ResponseReviewerSelect';
import ReviewerAssignment from 'v2/common/ReviewerAssignment/ReviewerAssignment';
import ReviewerAssignToMeButton from 'v2/common/ReviewerAssignToMeButton/ReviewerAssignToMeButton';
import SubmitToNomadButton from 'v2/common/SubmitToNomadButton/SubmitToNomadButton';
import { GenericObject, Permission, SearchEntity, User } from 'v2/models';
import { REVIEW_STATUS } from 'v2/utils/searchUtils';
import { FeatureToggle } from 'react-feature-toggles';
import { FEATURE_FLAGS } from 'utils/constants';
import { connect } from 'react-redux';

interface StateProps {
  permissions: { [key: string]: Permission };
  user: User;
}

interface OwnProps {
  search: SearchEntity;
  refetchFunction: () => void;
}

type ReviewerButtonsProps = StateProps & OwnProps;

const ReviewerButtons = ({
  search,
  permissions,
  user,
  refetchFunction,
}: ReviewerButtonsProps) => {
  const [isSubmittingReview, setIsSubmittingReview] = useState(false);
  const isCurrentSearchBadDescription =
    search.last_check_description &&
    search.last_check_description.result === 'bad';
  const isSubmittedByCurrUser = search?.submitted_by?.email === user.email;
  const isSearchReviewable =
    search.active &&
    !isSubmittedByCurrUser &&
    search.review_status === REVIEW_STATUS.UNDER_REVIEW;
  return (
    <div data-testid="reviewerTestButtons">
      {isSearchReviewable ? (
        <div
          className="d-flex flex-row mt-4 mb-3"
          onClick={(event) => event.preventDefault()}
        >
          <ReviewerAssignment
            user={user}
            search={search}
            permissions={permissions}
          >
            <div className="float-left">
              <div className="float-left mr-3">
                <ResponseReviewerSelect
                  search={search}
                  disabled={isSubmittingReview}
                  onSubmit={() => setIsSubmittingReview(true)}
                  onError={() => setIsSubmittingReview(false)}
                  onComplete={refetchFunction}
                />
              </div>
            </div>
            <SubmitToNomadButton
              search={search}
              disabled={isSubmittingReview || isCurrentSearchBadDescription}
              onSubmit={() => setIsSubmittingReview(true)}
              onError={() => setIsSubmittingReview(false)}
              onComplete={refetchFunction}
              tooltipMessage={
                isCurrentSearchBadDescription
                  ? 'The request description needs to be improved before you are able to submit to Nomad Data.'
                  : ''
              }
            />
            <FeatureToggle featureName={FEATURE_FLAGS.REVIEWER_ASSIGNMENT}>
              <ReviewerAssignToMeButton
                search={search}
                user={user}
                isLoading={isSubmittingReview}
                onComplete={refetchFunction}
              />
            </FeatureToggle>
          </ReviewerAssignment>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: GenericObject): StateProps => {
  return {
    user: state.user.user,
    permissions: state.permissions.permissions,
  };
};

export default connect<StateProps>(mapStateToProps)(ReviewerButtons);
